import {StoreExt} from '@utils/reactExt'
// import {routerStore} from '@src/store'

class HeaderStore extends StoreExt {
}

const headerStore = new HeaderStore()
export {headerStore, HeaderStore}
